<template>
  <div id="site-body" class="shop-cart-page" :style="getStyle" :class="{ 'is-empty': isEmpty }">
    <header-widget v-if="model.widgetList?.[0]" :site="model" :device="deviceType" :model="model.widgetList[0]" />
    <div v-if="deviceType === DeviceEnum.DESKTOP" class="shop-cart-page__container">
      <div class="shop-cart-page__content" :class="{ 'is-empty': isEmpty }">
        <template v-if="shopCartList.length || loseShopCartList.length">
          <div class="header-area">
            <div class="title">{{ $t('siteBuild.shopCart.title') }}</div>
            <div class="subtitle">
              <div class="back-link" @click="handleBack">
                <i class="el-icon-back" />
                <span>{{ $t('siteBuild.shopCart.backList') }}</span>
              </div>
              <div v-if="selectList.length" class="delete-all-btn" @click="handleRemoveAll">
                {{ $t('siteBuild.shopCart.allDelete') }}
              </div>
            </div>
          </div>
          <div class="tool-bar">
            <div class="col-check">
              <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="onSelectAllChange" />
              <span class="ml-2">{{ $t('siteBuild.shopCart.selectAll') }}</span>
            </div>
            <div class="col-product">
              <span>{{ $t('siteBuild.shopCart.goodsName') }}</span>
            </div>
            <div class="col-qty">
              <span>{{ $t('siteBuild.shopCart.number') }}</span>
            </div>
            <div class="col-price">
              <span>{{ $t('siteBuild.shopCart.price') }}</span>
            </div>
            <div class="col-action">
              <span>{{ $t('siteBuild.shopCart.handle') }}</span>
            </div>
          </div>
          <div v-loading="listLoading" class="shop-cart-page__wrapper">
            <div class="shop-cart-page__list">
              <div v-for="(item, index) in $store.state.goods.shopCartList"
                :key="'pc-list-item' + item.goods_id + index" class="cart-item"
                :class="{ 'is-disabled': item.goods_status !== 1 }">
                <div class="col-check">
                  <el-checkbox :value="item.goods_selected"
                    :disabled="item.goods_status !== ShopCartGoodsStatusEnum.normal"
                    @change="(checked) => onSelectChange(checked, item)" />
                </div>
                <div class="col-product">
                  <div class="goods-pic">
                    <img :src="item.goods_icon" class="object-cover" alt="">
                  </div>
                  <div class="goods-info">
                    <div class="goods-title">{{ getGoodsName(item.goods_names) }}</div>
                    <div class="goods-desc" v-html="getGoodDescription(item.goods_descriptions)" />
                    <div v-if="item.goods_limits" class="goods-limit">
                      Limit {{ item.goods_purchased_num }}/{{ item.goods_limits }}
                    </div>
                  </div>
                </div>
                <div class="col-qty">
                  <im-input-number :loading="numberLoading && currentGoods.goods_id === item.goods_id" :min="1"
                    :value="item.goods_num" @change="(number) => onNumberChange(item, number)" />
                </div>
                <div class="col-price">
                  <div class="price-wrapper">
                    <p class="current-price">{{ currencyLabel }} {{ item.goods_amount }}</p>
                    <p v-if="item.goods_amount_before_discount > item.goods_amount" class="origin-price">{{
                      currencyLabel }} {{ item.goods_amount_before_discount }}</p>
                  </div>
                </div>
                <div class="col-action">
                  <div class="remove-btn" @click="handleRemove(item, index)">
                    <i class="el-icon-close" />
                  </div>
                </div>
                <div v-if="item.goods_biz_list" class="gift-box">
                  <div class="gift-title">{{ $t('siteBuild.shopCart.gift') }}</div>
                  <div class="gift-list">
                    <template v-for="biz in item.goods_biz_list">
                      <div v-for="(gift, giftIndex) in biz.biz_gift_list"
                        :key="'pc-list-gift' + gift.gift_goods_id + giftIndex" class="gift-item">
                        <img :src="gift.logo" alt="">
                        <div class="gift-info">
                          <i class="el-icon-close"></i>
                          <span>{{ gift.num }}</span>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="loseShopCartList.length" class="shop-cart-page__lose">
              <div class="lose-header">共{{ loseShopCartList.length }}件已失效的商品</div>
              <div class="shop-cart-page__list">
                <div v-for="(item, index) in loseShopCartList" :key="'pc-list-lose-item' + item.goods_id + index"
                  class="cart-item is-lose">
                  <div class="col-check">
                    <el-checkbox disabled />
                  </div>
                  <div class="col-product">
                    <div class="goods-pic">
                      <img :src="item.goods_icon" class="object-cover" alt="">
                      <div class="lose-cover">已失效</div>
                    </div>
                    <div class="goods-info">
                      <div class="goods-title">{{ getGoodsName(item.goods_names) }}</div>
                      <div class="goods-desc" v-html="getGoodDescription(item.goods_descriptions)" />
                    </div>
                  </div>
                  <div class="col-qty">
                    <im-input-number disabled :value="item.goods_num" />
                  </div>
                  <div class="col-price">
                    <p class="current-price">{{ getShopCartGoodsPrice(item)?.priceTxt }}</p>
                  </div>
                  <div class="col-action">
                    <div class="remove-btn" @click="handleRemoveLoseItem(item, index)">
                      <i class="el-icon-close" />
                    </div>
                  </div>
                  <div v-if="item.goods_biz_list" class="gift-box">
                    <div class="gift-title">{{ $t('siteBuild.shopCart.gift') }}</div>
                    <div class="gift-list">
                      <template v-for="biz in item.goods_biz_list">
                        <div v-for="(gift, giftIndex) in biz.biz_gift_list" :key="'pc-list-lose-gift' + giftIndex"
                          class="gift-item">
                          <img :src="gift.logo" alt="">
                          <div class="gift-info">
                            <i class="el-icon-close"></i>
                            <span>{{ gift.num }}</span>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="shop-cart-page__handle">
            <div class="handle-info">
              <div class="total-price">{{ $t("siteBuild.shopCart.total") }} : <span>{{ currencyLabel }} {{
                shopCartTotalInfo.totalAmount
                  }}</span></div>
              <div v-if="shopCartTotalInfo.totalDiscountAmount > 0" class="discount-price">{{
                $t('siteBuild.discountTip') }}：{{
                currencyLabel }} {{ shopCartTotalInfo.totalDiscountAmount }}</div>
            </div>
            <el-button :loading="loading" class="buy-btn" type="primary" :disabled="submitDisabled"
              @click="handleSubmit">{{
                $t('siteBuild.shopCart.buy') }}({{ totalInfo.number }})</el-button>
          </div>
        </template>
        <div v-else-if="isEmpty" class="empty-state">
          <div class="empty-icon-wrapper">
            <img class="empty-icon" src="@/assets/img/no-data.png" alt="">
          </div>
          <div class="empty-text">{{ $t('siteBuild.shopCart.noData') }}</div>
          <button class="im-button primary-btn" @click="handleBack">{{ $t('siteBuild.shopCart.backList') }}</button>
        </div>
      </div>
    </div>
    <div v-if="deviceType === DeviceEnum.MOBILE" v-loading="listLoading" element-loading-background="#f0efef"
      class="shop-cart-page__mobile p-2 pb-[40px]" :class="{ 'is-empty': isEmpty }">
      <template v-if="shopCartList.length || loseShopCartList.length">
        <div class="flex items-center text-black px-4 py-2" @click="handleBack">
          <i class="el-icon-back text-16 mr-2" />
          <span>{{ $t('siteBuild.shopCart.backList') }}</span>
        </div>
        <div v-if="shopCartList.length" class="handle-box w-full flex items-center justify-between text-black mt-3">
          <el-checkbox v-model="checkAll" class="text-black font-normal" :indeterminate="isIndeterminate"
            @change="onSelectAllChange">{{ $t('siteBuild.shopCart.selectAll') }}</el-checkbox>
          <span v-if="selectList.length" @click="handleRemoveAll">{{ $t('siteBuild.shopCart.allDelete') }}</span>
        </div>
        <div class="list-box">
          <div v-for="(item, index) in shopCartList" :key="'mobile-list-item' + item.goods_id + index"
            class="list-box__item" :class="{ 'is-disabled': item.goods_status !== ShopCartGoodsStatusEnum.normal }">
            <div class="title flex items-center justify-between">
              <el-checkbox class="text-black text-18" :value="item.goods_selected"
                :disabled="item.goods_status !== ShopCartGoodsStatusEnum.normal"
                @change="(checked) => onSelectChange(checked, item)">{{ getGoodsName(item.goods_names) }}</el-checkbox>
              <i class="el-icon-close text-16 text-[#999]" @click="handleRemove(item)" />
            </div>
            <div class="flex mt-4">
              <div class="thumb flex-shrink-0 mr-3">
                <img class="rounded w-[78px] h-[78px] object-cover" :src="item.goods_icon" alt="">
                <div v-if="item.goods_limits"
                  class="border mt-2 mx-auto border-[#333] rounded text-center text-[#333] text-14">
                  Limit {{ item.goods_purchased_num }}/{{ item.goods_limits }}
                </div>
              </div>
              <div class="info w-full">
                <div class="text-[#999] desc" v-html="getGoodDescription(item.goods_descriptions)" />
                <div class="price-row flex items-center w-full justify-between text-black mt-4">
                  <div>
                    <div class="text-18">{{ currencyLabel }} {{ item.goods_amount }}</div>
                    <div v-if="item.goods_amount_before_discount > item.goods_amount" class="line-through text-[#999]">
                      {{ currencyLabel }} {{ item.goods_amount_before_discount }}</div>
                  </div>
                  <im-input-number :loading="numberLoading && currentGoods.goods_id === item.goods_id" :min="1"
                    size="small" :value="item.goods_num" @change="(number) => onNumberChange(item, number)" />
                </div>
              </div>
            </div>
            <div v-if="item.goods_biz_list" class="gift-box w-full">
              <div class="text-[#999]">{{ $t('siteBuild.shopCart.gift') }}</div>
              <div class="flex items-center mt-3 w-full overflow-x-auto">
                <template v-for="biz in item.goods_biz_list">
                  <div v-for="(gift, giftIndex) in biz.biz_gift_list" :key="'mobile-list-gift' + giftIndex"
                    class="gift-item flex items-center mr-6 flex-shrink-0">
                    <img class="w-[40px] h-[40px] rounded" :src="gift.logo" alt="">
                    <div class="flex items-center ml-3 text-[#999]">
                      <i class="el-icon-close"></i>
                      <span class="text-14">{{ gift.num }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div v-if="loseShopCartList.length" class="lose-area">
            <div class="text-black mb-3 mt-6">共{{ loseShopCartList.length }}件已失效的商品</div>
            <div v-for="(item, index) in loseShopCartList" :key="'mobile-list-lose-item' + item.goods_id"
              class="list-box__item">
              <div class="title flex items-center justify-between">
                <el-checkbox class="text-black text-18" disabled>{{ getGoodsName(item.goods_names) }}</el-checkbox>
                <i class="el-icon-close text-16 text-[#999]" @click="handleRemoveLoseItem(item, index)" />
              </div>
              <div class="flex mt-4">
                <div class="thumb w-[78px] h-[78px] flex-shrink-0 mr-3 relative">
                  <img class="rounded w-full h-full" :src="item.goods_icon" alt="">
                  <div class="lose-cover flex items-center justify-center">已失效</div>
                </div>
                <div class="info w-full">
                  <div class="text-[#999] desc" v-html="getGoodDescription(item.goods_descriptions)" />
                  <div class="flex items-center w-full justify-between text-black mt-4">
                    <span class="text-18">{{ getShopCartGoodsPrice(item)?.priceTxt }}</span>
                    <im-input-number size="mini" :number="item.goods_num" disabled />
                  </div>
                </div>
              </div>
              <div v-if="item.goods_biz_list" class="gift-box w-full">
                <div class="text-[#999]">{{ $t('siteBuild.shopCart.gift') }}</div>
                <div class="flex items-center mt-3 w-full overflow-x-auto">
                  <template v-for="biz in item.goods_biz_list">
                    <div v-for="(gift, giftIndex) in biz.biz_gift_list" :key="'mobile-list-lose-gift' + giftIndex"
                      class="gift-item flex items-center mr-6 flex-shrink-0">
                      <img class="w-[40px] h-[40px] rounded" :src="gift.logo" alt="">
                      <div class="flex items-center ml-3 text-[#999]">
                        <i class="el-icon-close"></i>
                        <span class="text-14">{{ gift.num }}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="text-black">
            <div class="text-18">{{ currencyLabel }} {{ shopCartTotalInfo.totalAmount }}</div>
            <div v-if="shopCartTotalInfo.totalDiscountAmount > 0" class="text-danger">{{ $t('siteBuild.discountTip')
              }}：{{
              currencyLabel }} {{ shopCartTotalInfo.totalDiscountAmount }}</div>
          </div>
          <el-button class="buy-button" type="primary" :loading="loading" :disabled="submitDisabled"
            @click="handleSubmit">{{
              $t('siteBuild.shopCart.buy') }}({{ totalInfo.number }})</el-button>
        </div>
      </template>
      <div v-else-if="isEmpty" class="empty-state">
        <div class="empty-icon-wrapper">
          <img class="empty-icon" src="@/assets/img/no-data.png" alt="">
        </div>
        <div class="empty-text">{{ $t('siteBuild.shopCart.noData') }}</div>
        <button class="im-button primary-btn" @click="handleBack">{{ $t('siteBuild.shopCart.backList') }}</button>
      </div>
    </div>
    <site-modals :device="deviceType" :site="model" />
    <order-modal />
    <desk-pay-modal v-if="deskPay.visible" :store-lang="$store.state.locale.locale"
      :lang-id-data="$store.state.locale.langIdData" :desk-pay="deskPay" @close="closePayModal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep, debounce, isNil } from 'lodash-es'
import { chain } from 'mathjs';
import { Message, InputNumber } from "element-ui"
import Bus from "~/site/model/bus"
import siteMixin from '~/mixins/site'
import goodMixins from "~/site/widgets/storeWidget/oneGood/goodMixins"
import HeaderWidget from "~/site/widgets/headerWidget/index.vue"
import SiteModals from "~/site/components/modals.vue"
import { DeviceEnum } from "~/enums/deviceEnum"
import ModernInputNumber from "~/components/common/ModernInputNumber.vue"
import DeskPayModal from '~/components/pay/deskPayModal.vue'
import tools from "~/utils"
import { isMobile } from "~/utils/types"
import { isBuildWebSite, PAY_URL } from "~/config"
import { PageEnum } from "~/enums/pageEnum"
import { ShopCartGoodsStatusEnum } from "~/enums/shopCartEnum"
import OrderModal from "~/site/components/orderModal/index.vue";
import { QueryKey } from '~/enums/tanstack'
import { queryCache } from '~/utils/queryCache'

const isSandBox = !isBuildWebSite
export default {
  name: 'ShopCartPage',
  components: {
    OrderModal,
    ImInputNumber: ModernInputNumber,
    SiteModals,
    HeaderWidget,
    DeskPayModal,
    InputNumber
  },
  mixins: [siteMixin, goodMixins],
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      ShopCartGoodsStatusEnum,
      return_url: '',
      checkAll: false,
      selectList: [],
      numberLoading: false,
      goodsList: [],
      loading: false,
      currencies: [],
      oldNumber: '',
      currenciesMap: {},
      isIndeterminate: false,
      listLoading: true,
      currentGoods: {},
      deskPay: {
        visible: false,
        isGoPay: true,
        payUrl: '',
        orderCode: ''
      }
    }
  },
  computed: {
    ...mapGetters(["shopCartNumber", 'shopCartTotalInfo', 'currencyLabel']),
    getStyle() {
      let style = {}
      const { globalSetting } = this.model
      if (globalSetting) {
        style = globalSetting.__vars
      }
      return style
    },
    isEmpty() {
      return !this.listLoading && (this.shopCartList.length === 0 && this.loseShopCartList.length === 0)
    },
    listHeight() {
      let h = 0
      this.shopCartList.forEach(item => {
        h = (item.goods_biz_list ? 278 : 152) + h
      })
      return h
    },
    loseListHeight() {
      let h = 0
      this.loseShopCartList.forEach(item => {
        h = (item.goods_biz_list ? 278 : 152) + h
      })
      return h
    },
    priceMap() {
      const result = {}
      const total = this.totalInfo
      const discountInfo = this.$store.state.goods.discountInfo
      this.$store.state.goods.shopCartList.forEach((item) => {
        const isSelect = this.selectList.find(goods => goods.goods_id === item.goods_id)
        const priceInfo = this.getShopCartGoodsPrice(item)
        const isDiscountGoods = item.is_discount_flag && isSelect
        const price = priceInfo.localRealPrice
        const isVCurrencyGoods = (discountInfo.full_discount_type === 1 && item.virtual_currency_id === discountInfo.virtual_currency_id) && (isDiscountGoods)
        const isCurrencyGoods = discountInfo.full_discount_type === 2 && (isDiscountGoods)
        result[item.goods_id] = {}
        result[item.goods_id].price = price
        result[item.goods_id].priceTxt = priceInfo.priceTxt
        if (isCurrencyGoods || isVCurrencyGoods) {
          result[item.goods_id].price = this.getMaxDiscountPrice(priceInfo.localRealPrice, total.originPrice, total.normalLocalPrice, total.price)
          result[item.goods_id].priceTxt = `${priceInfo.currencyLabel} ${result[item.goods_id].price}`
          result[item.goods_id].discount = price - result[item.goods_id].price
          result[item.goods_id].originPrice = price
          result[item.goods_id].originPriceTxt = `${priceInfo.currencyLabel} ${price}`
        }
      })
      return result
    },
    submitDisabled() {
      return this.selectList.length === 0
    },
    totalInfo() {
      const discountInfo = this.$store.state.goods.discountInfo
      const round = this.$store.state.user.currencyRound
      const total = this.selectList.reduce((total, item) => {
        const priceInfo = this.getShopCartGoodsPrice(item)
        const vCurrencyId = item.virtual_currency_id
        const vCurrencyPrice = priceInfo.vCurrencyPrice
        const isVCurrencyDiscountGoods = Boolean(item.is_discount_flag && (discountInfo.full_discount_type === 1) && (vCurrencyId === discountInfo.virtual_currency_id))
        const isCurrencyDiscountGoods = item.is_discount_flag && discountInfo.full_discount_type === 2
        total.originPrice = chain(priceInfo.localRealPrice).add(total.originPrice).round(round).value
        if (isVCurrencyDiscountGoods) total.vCurrencyTotalPrice = chain(vCurrencyPrice).add(total.vCurrencyTotalPrice).value
        if (isCurrencyDiscountGoods || isVCurrencyDiscountGoods) {
          total.discountTargetPrice = chain(priceInfo.targetRelPrice).add(total.discountTargetPrice).round(round).value
          total.discountLocalPrice = chain(priceInfo.localRealPrice).add(total.discountLocalPrice).round(round).value
        } else {
          total.normalLocalPrice = chain(total.normalLocalPrice).add(priceInfo.localRealPrice).round(round).value
        }
        total.label = priceInfo.currencyLabel
        total.number += Number(item.goods_num)
        return total
      }, { label: '', vCurrencyTotalPrice: 0, originPrice: 0, discountTargetPrice: 0, normalLocalPrice: 0, discountLocalPrice: 0, number: 0, discount: 0, localPrice: 0 })
      const discountPrice = this.getMaxDiscount(total.discountTargetPrice, total.discountLocalPrice, total.vCurrencyTotalPrice)
      total.discount = chain(total.discountLocalPrice).subtract(discountPrice).round(round).value
      total.price = chain(discountPrice).add(total.normalLocalPrice).round(round).value
      total.discountPrice = discountPrice
      return total
    },
    DeviceEnum() {
      return DeviceEnum
    },
    baseParams() {
      return {
        player_id: this.$store.state.user.siteLoginUserInfo?.player_id,
        project_id: this.$store.state.project?.projectId,
        site_id: this.$store.state.user.siteLoginUserInfo?.site_id
      }
    },
    deviceType() {
      return this.$store.state.device.device
    },
    shopCartList() {
      return this.$store.state.goods.shopCartList
    },
    loseShopCartList() {
      return this.$store.state.goods.loseShopCartList
    }
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      this.init()
    }
    Bus.$on('reloadGood', async (type) => {
      if (type === 'login-out') {
        this.handleBack()
      }
      await this.getShopCart(this)
      this.initShopCartStatus()
    })
  },
  methods: {
    ...mapActions({
      'getShopCart': 'goods/getShopCart'
    }),
    getItemStyle(list, item, prevIndex, gap = 0) {
      const currentIndex = prevIndex + 1
      let t = gap
      const h = item.goods_biz_list ? 278 : 152
      for (let i = 0; i < list.length; i++) {
        const current = list[i]
        const height = current.goods_biz_list ? 278 : 152
        if (i === currentIndex) {
          break
        }
        t = t + height + gap
      }
      return {
        transform: `translateY(${currentIndex === 0 ? 0 : t}px)`,
        height: `${h}px`
      }
    },
    async handleRemoveAll() {
      const params = {
        ...this.baseParams,
        goods_ids: this.selectList.map(item => item.goods_id)
      }
      this.listLoading = true
      const [err] = await this.$utils.to(this.$api.good.deleteShopCartGoods(params))
      this.listLoading = false
      if (!err) {
        this.selectList = []
        this.isIndeterminate = false
        this.$store.commit('goods/REMOVE_SHOP_CART_GOODS', params.goods_ids)
        this.updateCheckAll()
      } else {
        Message.error(err)
      }
    },
    async closePayModal() {
      queryCache.removeQueries([QueryKey.projectVipInfo])
      this.$store.commit('site/SET_SHOP_GOOD', null)
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
      // this.listLoading = true
      await this.getShopCart(this)
      // this.listLoading = false
      this.initShopCartStatus()
    },
    checkStatus() {
      if (isNil(this.$store.state.user.siteLoginUserInfo?.player_id)) {
        this.$store.commit('user/SET_LOGINSHOW', true)
        this.$store.commit('user/SET_SITE_BIND_USER', true)
        throw new Error('Not Found User Info')
      }
    },
    async createOrder() {
      const StoreIpInfo = tools.getLangByip(this)
      const { currency } = StoreIpInfo
      const {
        merchantId,
        projectId
      } = this.$store.state.project
      const ipInfo = tools.getxfip(localStorage) || {}
      const device = isMobile() ? 'mobile' : 'desktop'
      const lang = tools.getNeedParamsFormRouteParams(this.$route.params)?.lang || 'en'
      const params = {
        source: 1,
        project_id: projectId,
        merchant_id: merchantId,
        currency,
        amount: this.totalInfo.price,
        from_preview_mode: !isBuildWebSite,
        items: this.selectList.map(item => {
          const newItem = { ...item }
          const priceInfo = this.getRealPriceInfo(newItem.goods_prices)
          const price = +priceInfo.price
          return {
            item_id: newItem.goods_id,
            num: newItem.goods_num,
            amount: price,
            price,
            currency,
            virtual_currency: currency,
            virtual_currency_amount: price
          }
        }),
        settings: {
          device,
          view_source: this.$route.query.from,
          language: lang,
          show_order: false,
          return_url: this.return_url,
        },
      }
      this.loading = true
      const [err, res] = await this.$utils.to(this.$api.order.createOrder(params, ipInfo))
      this.loading = false
      if (!err) {
        this.openPayModal(res)
      } else {
        Message.error(err)
      }
    },
    openPayModal(res) {
      const sandbox = isSandBox ? 1 : 0
      const device = isMobile() ? 'mobile' : 'desktop'
      const { token, code } = res
      let payUrl = ''
      const env = process.env.RUN_ENV
      const isGoPay = token.slice(0, 2) === 'v2'
      if (isGoPay) {
        payUrl = `${PAY_URL[env]}/new-kop/payelement?access_token=${token}&sandbox=${+sandbox}`
      } else {
        payUrl = `${PAY_URL[env]}/pay/payelement?access_token=${token}&sandbox=${+sandbox}`
      }
      if (device === 'mobile') {
        this.$store.commit('site/SHOW_ORDER_MODAL', { payUrl, code, device })
      } else {
        this.deskPay = {
          visible: true,
          isGoPay,
          payUrl,
          orderCode: code
        }
      }
    },
    async handleSubmit() {
      this.checkStatus()
      await this.createOrder()
    },
    onSelectAllChange(checked) {
      this.isIndeterminate = false
      const getItems = () => {
        return this.selectList.map(item => {
          const newItem = { ...item }
          return {
            goods_id: newItem.goods_id,
            goods_num: newItem.goods_num,
            goods_selected: checked ? 1 : 2
          }
        })
      }
      let items = []
      if (checked) {
        this.selectList = cloneDeep(this.$store.state.goods.shopCartList.filter(item => item.goods_status === ShopCartGoodsStatusEnum.normal))
        items = getItems()
      } else {
        items = getItems()
        this.selectList = []
      }
      this.$store.commit('goods/UPDATE_ALL_GOODS_SELECT', checked)
      this.debounceUpdateGoodsSelect(items)
    },
    onSelectChange(checked, item) {
      const good = cloneDeep(item)
      if (checked) {
        this.selectList.push(good)
      } else {
        const index = this.selectList.findIndex(goodItem => goodItem.goods_id === good.goods_id)
        index > -1 && this.selectList.splice(index, 1)
      }
      this.$store.commit('goods/UPDATE_GOOD_SELECT', { good, checked })
      this.updateCheckAll()
      const items = [
        {
          goods_id: good.goods_id,
          goods_num: good.goods_num,
          goods_selected: checked ? 1 : 2
        }
      ]
      this.debounceUpdateGoodsSelect(items)
    },
    debounceUpdateGoodsSelect: debounce(async function (items) {
      const params = {
        ...this.baseParams,
        goods_item: items
      }
      const [err, res] = await this.$utils.to(this.$api.good.updateShopCartGoods(params))
      if (!err) {
        this.$store.commit('goods/SET_SHOP_CART_TOTAL_INFO', res)
        this.$store.commit('goods/SET_SHOP_CART_LIST', res.list)
      }
    }, 400),
    updateCheckAll() {
      this.checkAll = (this.selectList.length === this.$store.state.goods.shopCartList.length) && this.selectList.length !== 0
      this.isIndeterminate = this.selectList.length !== 0 && !this.checkAll
    },
    async getCurrencies() {
      const res = await this.$api.common.getCurrencies()
      this.currencies = res.data
      this.currenciesMap = {}
      this.currencies.forEach((c) => {
        this.currenciesMap[c.id] = c
      })
      this.$store.commit('project/SET_CURRENCYINFO', {
        currency: this.currencies,
        currencieMap: this.currenciesMap,
      })
    },
    async init() {
      document.body.classList.add('shop-cart-body')
      this.listLoading = true
      this.setDeviceWidth()
      await this.getUserInfo()
      await this.getShopCart(this)
      this.initShopCartStatus()
      this.listLoading = false
      this.return_url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?from=${this.$route.query?.from}`
    },
    initShopCartStatus() {
      this.selectList = []
      this.shopCartList.forEach(item => {
        if (item.goods_selected) {
          this.selectList.push(cloneDeep(item))
        }
      })
      this.updateCheckAll()
    },
    async handleRemoveLoseItem(item, index) {
      await this.handleRemove(item)
      this.$store.commit('goods/REMOVE_LOSE_ITEM', index)
    },
    updateGoodsNumber(item, number) {
      this.$nextTick(() => {
        const current = this.selectList.find(g => g.goods_id === item.goods_id)
        if (current) {
          current.goods_num = number
        }
        this.$store.commit('goods/UPDATE_GOOD_NUM', { good: item, number })
      })
    },
    async onNumberChange(item, number) {
      this.currentGoods = cloneDeep(item)
      const { goods_id, goods_num, goods_selected } = item
      console.log(this.currentGoods)
      const params = {
        ...this.baseParams,
        goods_item: [
          {
            goods_id,
            goods_num: Number(number),
            // 数量加减也要带上当前选中状态，否则后端会把 selected 写成 0（取消选中）
            goods_selected: goods_selected ? 1 : 2
          }
        ]
      }
      this.updateGoodsNumber(item, number)
      this.numberLoading = true
      const [err, res] = await this.$utils.to(this.$api.good.updateShopCartGoods(params))
      this.numberLoading = false
      if (!err) {
        this.$store.commit('goods/SET_SHOP_CART_TOTAL_INFO', res)
        this.$store.commit('goods/SET_SHOP_CART_LIST', res.list)
      } else {
        Message.error(err)
        this.updateGoodsNumber(item, goods_num)
      }
    },
    removeSelectGoods(ids) {
      ids.forEach(id => {
        const index = this.selectList.findIndex(g => g.goods_id === id)
        index > -1 && this.selectList.splice(index, 1)
      })
    },
    async handleRemove(item) {
      const params = {
        ...this.baseParams,
        goods_ids: [item.goods_id]
      }
      const [err, res] = await this.$utils.to(this.$api.good.deleteShopCartGoods(params))
      if (!err) {
        this.removeSelectGoods(params.goods_ids)
        this.$store.commit('goods/REMOVE_SHOP_CART_GOODS', params.goods_ids)
        this.$store.commit('goods/SET_SHOP_CART_TOTAL_INFO', res)
        this.$store.commit('goods/SET_SHOP_CART_LIST', res.list)
        this.updateCheckAll()
      }
    },
    handleBack() {
      window.location.href = window.location.href.replace(PageEnum.SHOP_CART, '')
    }
  }
}
</script>
<style lang="less">
body.shop-cart-body {
  background: #f7f9fc !important;
  overflow: unset !important;
}

.shop-cart-page {
  background-color: #f7f9fc;
  min-height: 100vh;

  &__container {
    max-width: 1280px;
    margin: 24px auto;
    padding: 0 24px;
  }

  &__content {
    background-color: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &.is-empty {
      justify-content: center;
      align-items: center;
    }
  }

  /* Header Area */
  .header-area {
    padding: 32px 40px;
    border-bottom: 1px solid #F3F4F6;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 28px;
      font-weight: 700;
      color: #111827;
      letter-spacing: -0.5px;
    }

    .subtitle {
      display: flex;
      gap: 24px;
      font-size: 14px;
      color: #6B7280;

      .back-link,
      .delete-all-btn {
        cursor: pointer;
        display: flex;
        align-items: center;
        transition: color 0.2s;

        &:hover {
          color: #3D46F5;
        }

        i {
          margin-right: 6px;
        }
      }
    }
  }

  /* Tool Bar */
  .tool-bar {
    display: flex;
    align-items: center;
    padding: 16px 40px;
    background-color: #F9FAFB;
    border-bottom: 1px solid #E5E7EB;
    color: #6B7280;
    font-size: 14px;
    font-weight: 500;
  }

  /* Grid Columns */
  .col-check {
    width: 8%;
    display: flex;
    align-items: center;
  }

  .col-product {
    width: 42%;
  }

  .col-qty {
    width: 20%;
    padding-left: 20px;
  }

  .col-price {
    width: 20%;
    text-align: right;
    padding-right: 40px;
  }

  .col-action {
    width: 10%;
    display: flex;
    justify-content: flex-end;
  }

  /* List Wrapper */
  .shop-cart-page__wrapper {
    flex: 1;
    overflow-y: auto;
    padding: 0;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #D1D5DB;
      border-radius: 3px;
    }
  }

  .shop-cart-page__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  /* Cart Item */
  .cart-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 32px 40px;
    border-bottom: 1px solid #F3F4F6;
    transition: background-color 0.2s;
    position: relative;

    &:hover {
      background-color: #FAFAFA;
    }

    &.is-disabled {
      opacity: 0.6;
      background-color: #F9FAFB;
    }

    .goods-pic {
      width: 96px;
      height: 96px;
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #E5E7EB;
      float: left;
      margin-right: 24px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .lose-cover {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 500;
      }
    }

    .goods-info {
      overflow: hidden;

      .goods-title {
        font-size: 18px;
        font-weight: 600;
        color: #111827;
        margin-bottom: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .goods-desc {
        font-size: 14px;
        color: #6B7280;
        margin-bottom: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .goods-limit {
        display: inline-block;
        padding: 2px 8px;
        border: 1px solid #E5E7EB;
        border-radius: 4px;
        font-size: 12px;
        color: #6B7280;
        background: white;
      }
    }

    .price-wrapper {
      .current-price {
        font-size: 20px;
        font-weight: 700;
        color: #111827;
      }

      .origin-price {
        font-size: 14px;
        color: #9CA3AF;
        text-decoration: line-through;
        margin-top: 4px;
      }
    }

    .remove-btn {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #9CA3AF;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: #FEE2E2;
        color: #EF4444;
      }
    }
  }

  /* Gift Box */
  .gift-box {
    width: 100%;
    margin-top: 24px;
    padding: 20px;
    background-color: #F8FAFC;
    border-radius: 12px;
    border: 1px dashed #E2E8F0;

    .gift-title {
      font-size: 13px;
      color: #64748B;
      margin-bottom: 12px;
      font-weight: 500;
    }

    .gift-list {
      display: flex;
      gap: 16px;
      overflow-x: auto;

      .gift-item {
        display: flex;
        align-items: center;
        background: white;
        padding: 8px;
        border-radius: 8px;
        border: 1px solid #E2E8F0;
        flex-shrink: 0;

        img {
          width: 40px;
          height: 40px;
          border-radius: 6px;
          object-fit: cover;
        }

        .gift-info {
          margin-left: 12px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #64748B;
          padding-right: 8px;

          i {
            font-size: 12px;
            margin-right: 2px;
          }
        }
      }
    }
  }

  /* Lose Area */
  .shop-cart-page__lose {
    border-top: 1px solid #F3F4F6;
    margin-top: 20px;

    .lose-header {
      padding: 24px 40px;
      font-size: 16px;
      font-weight: 500;
      color: #374151;
      background: #F9FAFB;
    }

    .cart-item.is-lose {
      background-color: #F9FAFB;

      .goods-title,
      .goods-desc,
      .current-price {
        color: #9CA3AF;
      }
    }
  }

  /* Bottom Handle */
  .shop-cart-page__handle {
    height: 96px;
    padding: 0 40px;
    border-top: 1px solid #E5E7EB;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: white;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.02);

    .handle-info {
      text-align: right;
      margin-right: 32px;

      .total-price {
        font-size: 16px;
        color: #374151;

        span {
          font-size: 28px;
          font-weight: 700;
          color: #111827;
          margin-left: 8px;
        }
      }

      .discount-price {
        font-size: 14px;
        color: #EF4444;
        margin-top: 4px;
      }
    }

    .buy-btn {
      height: 52px;
      padding: 0 48px;
      font-size: 18px;
      font-weight: 600;
      border-radius: 10px;
      background-color: @primary-color;
      border-color: @primary-color;
      box-shadow: 0 4px 12px rgba(61, 70, 245, 0.3);
      transition: all 0.2s;

      &:hover {
        transform: translateY(-1px);
        background-color: @primary-1;
        border-color: @primary-1;
        box-shadow: 0 6px 16px rgba(61, 70, 245, 0.4);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  /* Empty State */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    animation: fadeIn 0.5s ease-out;

    .empty-icon-wrapper {
      width: 240px;
      height: 240px;
      background: linear-gradient(135deg, #F3F4F6 0%, #FFFFFF 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 32px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
      position: relative;

      &::after {
        content: '';
        position: absolute;
        inset: -10px;
        border-radius: 50%;
        border: 2px dashed #E5E7EB;
        // animation: spin 30s linear infinite;
      }

      .empty-icon {
        width: 140px;
        opacity: 0.9;
        transform: translateY(-5px);
        transition: transform 0.3s ease;
      }

      &:hover .empty-icon {
        transform: translateY(-10px) scale(1.05);
      }
    }

    .empty-text {
      font-size: 20px;
      color: #374151;
      font-weight: 600;
      margin-bottom: 12px;
    }

    .empty-desc {
      font-size: 14px;
      color: #9CA3AF;
      margin-bottom: 32px;
      max-width: 300px;
      text-align: center;
      line-height: 1.6;
    }

    .primary-btn {
      padding: 12px 48px;
      background: @primary-color;
      color: white;
      border: none;
      border-radius: 24px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 4px 12px rgba(61, 70, 245, 0.2);

      &:hover {
        background: @primary-1;
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(61, 70, 245, 0.3);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Mobile Styles - Keep mostly as is but refresh colors */
  &__mobile {
    background: #F3F4F6;
    min-height: 100vh;
    padding-bottom: 120px !important;

    .handle-box {
      background-color: white;
      border-radius: 12px;
      padding: 12px 16px;
      margin-bottom: 12px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    }

    .list-box {
      margin-top: 10px;
      padding-bottom: 20px;

      &__item {
        background-color: white;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 12px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        position: relative;
        overflow: hidden;

        &.is-disabled {
          opacity: 0.6;
          background-color: #FAFAFA;
        }

        .title {
          margin-bottom: 12px;

          .el-checkbox__label {
            font-size: 16px;
            font-weight: 500;
            color: #111827;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 200px;
            vertical-align: middle;
          }
        }

        .thumb {
          img {
            object-fit: cover;
            border: 1px solid #dedede;
          }

          .lose-cover {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
          }
        }

        .info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .desc {
            font-size: 13px;
            color: #6B7280;
            line-height: 1.4;
            margin-bottom: 8px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .price-row {
            margin-top: auto;
          }

          .text-18 {
            font-size: 18px;
            font-weight: 600;
            color: #111827;
          }
        }
      }
    }

    .bottom-box {
      padding: 12px 16px;
      padding-bottom: calc(12px + constant(safe-area-inset-bottom));
      padding-bottom: calc(12px + env(safe-area-inset-bottom));
      background-color: white;
      position: fixed;
      width: 100%;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 100;
      box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.05);
      border-top: 1px solid #F3F4F6;

      .text-black {
        .text-18 {
          font-size: 18px;
          font-weight: 700;
          color: #111827;
        }

        .text-danger {
          font-size: 12px;
          color: #EF4444;
        }
      }

      .buy-button {
        height: 44px;
        padding: 0 32px;
        color: white;
        border: none;
        background: #3D46F5;
        border-radius: 22px;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 12px rgba(61, 70, 245, 0.3);
        transition: all 0.2s;

        &:active {
          transform: scale(0.96);
        }

        &.is-disabled {
          opacity: 0.5;
          background: #9CA3AF;
          box-shadow: none;
        }
      }
    }

    /* Mobile Empty State Override */
    .empty-state {
      padding: 40px 20px;
      height: 80vh;

      .empty-icon-wrapper {
        width: 180px;
        height: 180px;
        margin-bottom: 24px;

        .empty-icon {
          width: 100px;
        }
      }

      .empty-text {
        font-size: 18px;
        margin-bottom: 8px;
      }

      .empty-desc {
        font-size: 13px;
        margin-bottom: 24px;
        max-width: 260px;
      }

      .primary-btn {
        padding: 10px 40px;
        font-size: 15px;
      }
    }
  }
}
</style>
